/**
 * Layout Component
 *
 * Main layout wrapper with Header and Footer.
 * Uses the SZU design system with proper spacing and structure.
 */

import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { useLanguageSync } from '@/hooks/useLanguageSync';

/**
 * Layout component wrapping pages with Header and Footer
 *
 * Features:
 * - Sticky header with SZU blue background
 * - Flexible main content area
 * - Footer pushed to bottom on short pages
 * - Proper spacing between sections
 * - Language sync with URL parameter (?lang=cs or ?lang=en)
 *
 * @example
 * ```tsx
 * <Route element={<Layout />}>
 *   <Route path="/" element={<HomePage />} />
 *   <Route path="/catalog" element={<CatalogPage />} />
 * </Route>
 * ```
 */
export function Layout() {
  // Sync language with URL parameter
  useLanguageSync();

  return (
    <div className="flex min-h-screen flex-col bg-background">
      {/* Sticky header with SZU blue background */}
      <Header />

      {/* Main content area with proper spacing */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer with SZU gray background */}
      <Footer />
    </div>
  );
}

export default Layout;
